import { render, staticRenderFns } from "./IrOrderReship.vue?vue&type=template&id=78ba3b3e&"
import script from "./IrOrderReship.vue?vue&type=script&lang=js&"
export * from "./IrOrderReship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports